<app-section-layout [itemTemplate]="sbuGraph" [dataForChart]="graphData" (onIntersection)="onIntersectionChange($event)" ></app-section-layout>

<ng-template #sbuGraph let-data="data" let-sectionNavState="sectionNavState">
    <app-sbu-slide [sbuGraph]="data.graph" [navState]="sectionNavState" [isLoading]="isLoading" ></app-sbu-slide>
</ng-template>